<script>
import { getPartyBuildingIndex } from '@/api/partyTop'

import { getImgSrcArr, partyBuildingImgPath } from '@/utils/filters'

export default {
  data() {
    return {
      partyBuildingList: [],
      hyPartyHistoryList: [],
      deedsImg: '',
      deedsTitleid: 0,
      ruralList: [],
      migrantServiceList: [
        { label: '活动开展', icon: require('imgs/partyTop/party-building/migration-service-activity.png') },
        { label: '维权帮助', icon: require('imgs/partyTop/party-building/migration-service-help.png') },
        { label: '服务保障', icon: require('imgs/partyTop/party-building/migration-service-s.png') },
        { label: '风采展示', icon: require('imgs/partyTop/party-building/migration-service-elegance.png') }
      ],
      pbIntroMore: false
    }
  },
  computed: {
    partyBuildingListCo() {
      let memberList = []
      for (let i = 0; i < this.partyBuildingList.length; i += 3) {
        memberList.push(this.partyBuildingList.slice(i, i + 3))
      }
      return memberList
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    getImgSrcArr, partyBuildingImgPath,
    onPageBack() {
      this.$router.go(-1)
    },
    toPbDetail(label, value) {
      let titleid = 0
      switch (label) {
        case '党建洪雅': titleid = 0
          break
        case '洪雅党史': titleid = this.hyPartyHistoryList[0].titleid
          break
        case '先进事迹': titleid = this.deedsTitleid
          break
        case '乡村振兴': titleid = this.ruralList[0].titleid
          break
        default: titleid = 0
      }
      this.$router.push({ path: '/partyBuildingDetail', query: { label, titleid, id: value?.id || 0 }})
    },
    initPageData() {
      getPartyBuildingIndex().then(res => {
        const { code, msg = [], msg2 = [], msg3 = [], msg4 = [] } = res
        if (code === 0) {
          this.partyBuildingList = msg
          this.hyPartyHistoryList = msg2
          // this.deedsImg = msg3[0]?.photo || ''
          this.deedsTitleid = msg3[0]?.titleid || 0
          this.ruralList = msg4
        }
      })
    }
  }
}
</script>

<template>
  <div class="page-container">
    <div class="page-logo-container">
      <el-image class="hy-logo" :src="require('imgs/partyTop/hy-logo.png')" alt="hy-logo" />
      <p class="page-title">洪雅智慧党建</p>
    </div>

    <div class="main-container">
      <div class="main-item left-party-building">
        <el-image
          :src="require('imgs/partyTop/party-building/hy-pb-title.png')"
          alt="party-building-title"
          class="party-building-title"
        />
        <div class="pb-box">
          <p class="party-building-intro" :class="{'h-line-2': !pbIntroMore}">
            高举中国特色社会主义伟大旗帜，全面贯彻新时代中国特色社会主义思想，弘扬伟大建党精神，自信自强、守正创新，踔厉奋发、勇毅前行，为全面建设社会主义现代化国家、全面推进中华民族伟大复兴而团结奋斗。
          </p>
          <p class="party-building-intro-tool" @click="pbIntroMore = !pbIntroMore">
            {{ pbIntroMore ? '收起' : '展开' }}
            <i :class="pbIntroMore ? 'el-icon-arrow-up' : 'el-icon-arrow-right'" />
          </p>
        </div>
        <div class="party-building-list-container">
          <div class="party-building-list-container-shadow">
            <div v-for="(item, idx) in partyBuildingListCo" :key="`item-three-${idx}`" class="item-three">
              <div
                v-for="(v, i) in item"
                :key="`party-building-item-${i}`"
                class="list-item"
                @click="toPbDetail('党建洪雅', v)"
              >
                <el-image :src="getImgSrcArr(v.memo)[0]" fit="cover" alt="item" class="item-img" />
                <div class="item-center">
                  <p class="h-line-1 center-title">{{ v.headline }}</p>
                  <p class="h-line-2 center-content">{{ v.memo | filtersRichtext }}</p>
                </div>
                <div class="item-icon">
                  <i class="el-icon-arrow-right" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-item center-party-history">
        <div class="party-history" @click="toPbDetail('洪雅党史')">
          <div class="party-history-title">
            <p class="title-text left-text">洪雅</p><p class="title-text">党史</p>
          </div>
          <p class="h-line-2 party-histroy-intro">
            岁月铭记，百年逐梦。档案见证，风雨历程。铭记初心，洪雅党史回眸。
          </p>
          <div class="party-history-list">
            <div v-for="(v, i) in hyPartyHistoryList.slice(0, 2)" :key="`party-history-item-${i}`" class="list-item">
              <el-image :src="v.photo | partyBuildingImgPath" fit="cover" alt="party" class="item-img" />
              <p class="h-line-2 item-title">{{ v.headline }}</p>
            </div>
          </div>
        </div>
        <!-- :style="{background: `url(${partyBuildingImgPath(deedsImg)}) no-repeat center`, backgroundSize: '100% 100%'}" -->
        <div class="party-history-deeds" @click="toPbDetail('先进事迹')">
          <div class="deeds-content">
            <div class="title-box">
              <p class="title-text">先进事迹</p>
              <p class="icon-box"><i class="el-icon-right" /></p>
            </div>
            <el-image :src="require('imgs/partyTop/party-building/deeds-bg-shadow.png')" class="deeds-bg-shadow" />
          </div>
        </div>
        <el-image :src="require('imgs/partyTop/party-building/deeds-bg-bb.png')" class="deeds-bg-bb" />
      </div>

      <div class="main-item right-party-branch">
        <div class="pb-title" @click="toPbDetail('青年党支部')">
          <p class="title-text">青年党支部</p>
          <i class="el-icon-right" />
        </div>
        <div class="rural-vitalization" @click="toPbDetail('乡村振兴')">
          <div class="rv-title">
            <p class="title-text">乡村振兴</p>
            <i class="el-icon-right" />
          </div>
          <div class="rv-list">
            <div v-for="(v, i) in ruralList.slice(0, 3)" :key="`rv-item-${i}`" class="list-item">
              <p class="h-line-1 item-title">{{ v.headline }}</p>
              <i class="el-icon-arrow-right" />
            </div>
          </div>
        </div>
        <div class="migrant-service">
          <div class="ms-title">
            <p class="title-text">农民工服务</p>
            <i class="el-icon-right" />
          </div>
          <div class="ms-list">
            <div
              v-for="(v, i) in migrantServiceList"
              :key="`ms-list-item-${i}`"
              class="list-item"
              @click="toPbDetail(v.label)"
            >
              <el-image :src="v.icon" :alt="v.label" class="item-icon" />
              <p class="item-label">{{ v.label }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-image
      :src="require('imgs/partyTop/party-building/return.png')"
      alt="return"
      class="return-img"
      @click="onPageBack"
    />
  </div>
</template>

<style lang="scss" scoped>
.page-container {
  width: 100%;
  min-height: 100vh;
  // background: fff;
  background: url('~imgs/partyTop/party-building/index-bg.webp') no-repeat center;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  position: relative;
  .page-logo-container {
    position: absolute;
    top: 26px;
    left: 26px;
    display: flex;
    column-gap: 16px;
    .hy-logo {
      width: 87px;
      height: 50px;
    }
    .page-title {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
      margin-top: 2px;
      letter-spacing: 3px;
    }
  }
  .return-img {
    position: absolute;
    width: 132px;
    height: 52px;
    bottom: 0;
    left: 894px;
    cursor: pointer;
  }
}
.main-container {
  width: 1700px;
  height: 782px;
  margin-top: 126px;
  display: flex;
  justify-content: space-between;
  .main-item {
    box-sizing: border-box;
  }
}
.left-party-building {
  width: 624px;
  .party-building-title {
    width: 314px;
    height: 82px;
    margin-top: 20px;
  }
  .pb-box {
    height: 200px;
  }
  .party-building-intro {
    width: 376px;
    font-size: 17px;
    color: #F9CA97;
    line-height: 24px;
    margin-top: 28px;
    text-shadow: 0px 0px 10px rgba(207, 4, 8, .8);
  }
  .party-building-intro-tool {
    width: 376px;
    text-align: right;
    font-size: 12px;
    color: #fff;
    margin-top: 2px;
    text-shadow: 0px 0px 10px rgba(207, 4, 8, .8);
    cursor: pointer;
  }
  .party-building-list-container {
    width: 624px;
    height: 420px;
    margin-top: 30px;
    cursor: pointer;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      height: 420px;
      width: 80px;
      right: 0;
      bottom: 0;
      box-shadow: #fff -50px 0 30px -18px inset;
      z-index: 2;
      border-radius: 0 30px 30px 0;
    }
    .party-building-list-container-shadow {
      width: 624px;
      height: 420px;
      background: #fff;
      border-radius: 30px;
      display: flex;
      column-gap: 30px;
      padding: 30px;
      box-sizing: border-box;
      overflow-x: scroll;
      scroll-behavior: smooth;
      // overflow-y: hidden;
      &::-webkit-scrollbar { // chrome/safari
        display: none;
      }
      scrollbar-width: none; // firefox
      -ms-overflow-style: none; // IE10+
    }
    .item-three {
      display: flex;
      flex-direction: column;
      row-gap: 30px;
    }
    .list-item {
      width: 370px;
      height: 100px;
      background: rgba(247,247,247,0);
      border: 1px solid #FD0000;
      border-radius: 15px;
      padding: 0 0 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .item-img {
        width: 82px;
        height: 80px;
        border-radius: 8px;
      }
      .item-center {
        width: 228px;
        padding: 0 10px 0 0;
        box-sizing: border-box;
        .center-title {
          font-size: 17px;
          font-weight: bold;
          color: #222F3E;
        }
        .center-content {
          font-size: 15px;
          color: #999;
          line-height: 23px;
          margin-top: 10px;
        }
      }
      .item-icon {
        width: 15px;
        height: 27px;
        background: #FD0000;
        border-radius: 6px 0px 0px 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 14px;
      }
    }
  }
}
.center-party-history {
  width: 500px;
  height: 782px;
  position: relative;
  cursor: pointer;
  .party-history {
    position: absolute;
    top: 0;
    left: 0;
    width: 500px;
    height: 560px;
    background: url('~imgs/partyTop/party-building/deeds-bg-top.png') no-repeat center;
    background-size: 100% 100%;
    display: table;
    z-index: 2;
    .party-history-title {
      display: flex;
      align-items: center;
      margin-top: 34px;
      .title-text {
        font-size: 36px;
        font-family: siyuansong;
        font-weight: bold;
        color: #000;
      }
      .left-text {
        width: 113px;
        height: 50px;
        line-height: 50px;
        background-color: #D6050B;
        border-radius: 0px 10px 10px 0px;
        text-align: end;
        color: #fff;
      }
    }
    .party-histroy-intro {
      width: 406px;
      font-size: 15px;
      color: #333;
      line-height: 24px;
      margin: 20px 0 0 44px;
    }
    .party-history-list {
      display: flex;
      column-gap: 20px;
      margin: 36px 0 0 40px;
      .list-item {
        .item-img {
          width: 172px;
          height: 129px;
          border-radius: 10px;
        }
        .item-title {
          width: 156px;
          font-size: 15px;
          color: #333;
          line-height: 24px;
          margin-top: 18px;
        }
      }
    }
  }
  .party-history-deeds {
    position: absolute;
    bottom: 14px;
    left: 0;
    width: 490px;
    height: 384px;
    background: url('~imgs/partyTop/party-building/deeds-bg.webp') no-repeat top;
    background-size: 100% 100%;
    z-index: 1;
    // -webkit-clip-path: polygon(0 60%, 100% 0, 100% 100%, 0 100%);
    // clip-path: polygon(0 60%, 100% 0, 100% 100%, 0 100%);
    .deeds-content {
      width: 490px;
      height: 100%;
      background: url('~imgs/partyTop/party-building/deeds-bg-bottom.webp') no-repeat center;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      position: relative;
      .title-box {
        position: absolute;
        bottom: 35px;
        left: 40px;
        width: 460px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        z-index: 2;
        .title-text {
          font-size: 36px;
          font-family: siyuansong;
          font-weight: bold;
          color: #333;
          // text-shadow: 2px 3px 1px #fff;
        }
        .icon-box {
          width: 76px;
          height: 51px;
          background: #D6050B;
          border-radius: 10px 0px 0px 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          .el-icon-right {
            font-size: 40px;
            color: #fff;
          }
        }
      }
      .deeds-bg-shadow {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 490px;
        height: 398px;
        opacity: .7;
        z-index: 1;
      }
    }
  }
  .deeds-bg-bb {
    width: 468px;
    height: 69px;
    position: absolute;
    bottom: 0;
    left: 11px;
  }
}
.right-party-branch {
  width: 496px;
  .pb-title {
    width: 496px;
    height: 114px;
    background: url('~imgs/partyTop/party-building/party-branch-bg.png') no-repeat center;
    background-size: 100% 100%;
    padding: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .title-text {
      font-size: 29px;
      font-family: siyuansong;
      font-weight: bold;
      color: #333;
    }
    .el-icon-right {
      color: #E5E5E5;
      font-size: 44px;
    }
  }
  .rural-vitalization {
    width: 496px;
    height: 250px;
    background-color: rgba(160, 0, 0, 0.5);
    border: 4px solid rgba(255, 255, 255, 0.4);
    border-radius: 30px;
    padding: 20px 30px;
    box-sizing: border-box;
    margin-top: 40px;
    cursor: pointer;
    .rv-title {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-text {
        font-size: 29px;
        font-family: siyuansong;
        font-weight: bold;
        color: #fff;
      }
      .el-icon-right {
        font-size: 40px;
        color: #fff;
      }
    }
    .rv-list {
      display: flex;
      flex-direction: column;
      row-gap: 30px;
      margin-top: 20px;
      .list-item {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item-title {
          width: 358px;
          font-size: 17px;
          color: #fff;
        }
        .el-icon-arrow-right {
          color: #fff;
        }
      }
    }
  }
  .migrant-service {
    width: 496px;
    height: 330px;
    background: url('~imgs/partyTop/party-building/ms-bg.png') no-repeat center;
    background-size: 100% 100%;
    padding: 40px;
    box-sizing: border-box;
    margin-top: 40px;
    cursor: pointer;
    .ms-title {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title-text {
        font-size: 29px;
        font-family: siyuansong;
        font-weight: bold;
        color: #000;
      }
      .el-icon-right {
        font-size: 40px;
        color: #E6E6E6;
      }
    }
    .ms-list {
      width: 386px;
      display: flex;
      flex-wrap: wrap;
      column-gap: 88px;
      row-gap: 18px;
      margin-top: 16px;
      .list-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-icon {width: 70px;height: 70px;}
        .item-label {
          font-size: 17px;
          font-weight: bold;
          color: #333;
        }
      }
    }
  }
}
</style>
